import * as stylex from "@stylexjs/stylex";
import { colors, radii } from "@softmax/design-system/tokens.stylex";

export type CoworldHeaderArt =
  | { readonly kind: "icon"; readonly src: string }
  | { readonly kind: "cover"; readonly src: string | undefined }
  | { readonly kind: "monogram"; readonly text: string };

const wide = "@media (min-width: 640px)";

export function CoworldArt({
  art,
  anchored,
}: {
  readonly art: CoworldHeaderArt;
  readonly anchored: boolean;
}) {
  return (
    <>
      {art.kind === "icon" ? (
        <img
          src={art.src}
          alt=""
          {...stylex.props(styles.art, styles.icon, anchored && styles.artTop)}
        />
      ) : art.kind === "monogram" ? (
        <div
          aria-hidden
          {...stylex.props(
            styles.art,
            styles.cover,
            styles.monogram,
            anchored && styles.artTop,
          )}
        >
          {art.text}
        </div>
      ) : (
        <div
          {...stylex.props(styles.art, styles.cover, anchored && styles.artTop)}
        >
          {art.src === undefined ? null : (
            <img src={art.src} alt="" {...stylex.props(styles.crop)} />
          )}
        </div>
      )}
    </>
  );
}

const styles = stylex.create({
  artTop: {
    gridColumnStart: 1,
    gridRowStart: 1,
    gridRowEnd: 2,
    alignSelf: "start",
    width: 120,
    height: 120,
  },
  art: {
    gridColumnStart: 1,
    gridRowStart: 1,
    gridRowEnd: { default: "auto", [wide]: 6 },
    width: { default: 120, [wide]: 194 },
    height: { default: 120, [wide]: 194 },
    alignSelf: { default: "auto", [wide]: "center" },
  },
  icon: { display: "block" },
  cover: {
    position: "relative",
    overflow: "hidden",
    borderRadius: { default: radii.large, [wide]: radii.extraLarge },
    backgroundColor: colors.surfaceAlt,
    height: { default: 120, [wide]: 195 },
  },
  monogram: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colors.foreground,
    fontSize: { default: 40, [wide]: 64 },
    fontWeight: 600,
  },
  crop: {
    position: "absolute",
    top: 0,
    left: "-86.45%",
    height: "161.29%",
    width: "auto",
    maxWidth: "none",
  },
});
